export var modal = function modal() {
  document.querySelectorAll('.js-open-modal').forEach((button) => {
    button.addEventListener('click', () => {
      document.body.classList.add('no-scroll');
      document.getElementById(button.dataset.modal).classList.add('is-open');
    });
  });


  document.querySelectorAll('.js-modal').forEach((modal) => {
    modal.querySelectorAll('.js-close-modal').forEach((button) => {
      button.addEventListener('click', () => {
        document.body.classList.remove('no-scroll');
        modal.classList.remove('is-open');
      });
    });
  });
}
